import { createBrowserHistory } from 'history';
import {
  CARD_NUMBER_FORMAT,
  addToCartPayload,
  AUTH_PATH,
  CHECK_BALANCE_RESTRICTED_PROGRAM
} from './consts';

export const getAddToCartPayload = (
  amount,
  availableAmount,
  cardNumber,
  savedPaymentId,
  cardLast4
) => {
  let digits = '';

  const _addToCartPayload = {
    ...addToCartPayload
  };
  if (cardNumber) {
    digits = cardNumber.slice(4, 16);
    _addToCartPayload.items.delivery[0].config.cardNumber = digits;
  }
  if (savedPaymentId) {
    _addToCartPayload.items.delivery[0].config.savedPaymentId = savedPaymentId;
  }
  const last4 = cardLast4 || digits.slice(8, 12);
  _addToCartPayload.items.delivery[0].config = {
    ..._addToCartPayload.items.delivery[0].config,
    name: `Giftcard - Reload. Card ending ${last4} *******`,
    price: amount.toString(),
    availableAmount: availableAmount.toString()
  };

  return _addToCartPayload;
};

function nextDigit(input, cursorpos, isBackspace) {
  if (isBackspace) {
    for (let i = cursorpos - 1; i > 0; i -= 1) {
      if (/\d/.test(input[i])) {
        return i;
      }
    }
  } else {
    for (let i = cursorpos - 1; i < input.length; i += 1) {
      if (/\d/.test(input[i])) {
        return i;
      }
    }
  }

  return cursorpos;
}

function patternMatch({ input, _template }) {
  try {
    let pos = 0;
    let plaintext = '';
    let countPos = 0;
    let template = _template;
    while (pos < template.length) {
      if (countPos > input.length - 1) {
        template = template.substring(0, pos);
        break;
      }

      if (template[pos] === input[pos]) {
        pos += 1;
        countPos += 1;
      }

      if (template[pos] === 'x') {
        template = template.substring(0, pos) + input[countPos] + template.substring(pos + 1);
        plaintext += input[countPos];
        countPos += 1;
      }
      pos += 1;
    }

    return template;
  } catch {
    return '';
  }
}

export const formatCardNumber = (str, selectionStart, isBackspace) => {
  const formatted = patternMatch({
    input: str,
    _template: CARD_NUMBER_FORMAT
  });
  let nextCusPos = nextDigit(formatted, selectionStart, isBackspace);
  return { formatted, nextCusPos };
};

export const isNumber = (str) => {
  let pattern = /^\d+\.?\d*$/;
  return pattern.test(str);
};

export const removeSpaces = (str) => {
  return str.replace(/\s/g, '');
};

export const validateCardNumber = (number, restrictedProgramCodes) => {
  if (number && number.length !== 23) {
    return 'Please provide the entire 23-digit gift card number.';
  }
  const programCode = number?.slice(5, 7);
  if ((restrictedProgramCodes || CHECK_BALANCE_RESTRICTED_PROGRAM).includes(programCode)) {
    return 'That doesn\'t seem to be a valid gift card number. Please try re-entering the number.';
  }
  return '';
};

export const maskCardNumber = (gcNumber) => {
  let maskedNumber = gcNumber.length === 4 ? gcNumber : gcNumber.slice(12, 16);
  return `**** ****** **${maskedNumber} *******`;
};

export const spiltAmount = (balAmt) => {
  return balAmt.toString()?.split('.')?.[1];
};

export const getReCaptchaKey = () => {
  if (typeof window !== 'undefined') {
    if (window.location.hostname.includes('homedepot.com')) {
      return '6Lea0tUpAAAAACQWL8B50wZmE2m6Ke2uLOWyG2lT';
    }
    if (window.location.hostname.includes('qa74')) {
      return '6LdJcccpAAAAAAHREK5RTRMg2GLq3mpLRGZ0q_8l';
    }
    return '6LdJcccpAAAAAAHREK5RTRMg2GLq3mpLRGZ0q_8l';
  }
  return '';
};

export const isLocalHost = () => {
  if (typeof window !== 'undefined') {
    const loc = window.location.pathname;
    const host = !!loc.match(/chapters/g);
    return host;
  }
  return false;
};

export const getUrlParam = (param) => {
  const searchParams = typeof window !== 'undefined' ? window?.top.location?.search : '';
  const urlParams = new URLSearchParams(searchParams);
  return urlParams.get(param);
};

export const getTmxId = () => {
  let nativeTMXID;
  if (typeof window !== 'undefined' && window.__EXPERIENCE_CONTEXT__?.isConsumerApp) {
    nativeTMXID = getUrlParam('guid');
  }
  return (
    nativeTMXID
    || (typeof window !== 'undefined' && window.top.THD_ACCOUNT_LIB?.TMX?.getTMXsessionId())
  );
};

export const goToAuth = () => {
  const history = createBrowserHistory();
  setTimeout(() => {
    history.push(AUTH_PATH);
    history.go();
  }, 100);
};

export const getGQLErrors = (error) => {
  if (!error) {
    return null;
  }
  const errors = error?.graphQLErrors?.[0]?.extensions?.errors
    || error?.graphQLErrors?.[0]?.extensions?.customer_payment_info;
  return errors;
};
